import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import customerReducer from "./slices/customerSlice";
import inquiryReducer from "./slices/inquirySlice";
import notificationReducer from "./slices/notificationSlice";
import paymentLinkingReducer from "./slices/paymentLinkingSlice"; // ⭐ Import paymentLinkingReducer
import paymentReducer from "./slices/paymentSlice";
import styleReducer from "./slices/styleSlice"; // ⭐ Import styleReducer

// ⭐ Configuration untuk persist style
const stylePersistConfig = {
  key: "style",
  storage,
  // whitelist: ["primary_color", "secondary_color", "logo_url"], // Optional: specify which fields to persist
};

// ⭐ Wrap styleReducer dengan persistReducer
const persistedStyleReducer = persistReducer(stylePersistConfig, styleReducer);

const store = configureStore({
  reducer: {
    payment: paymentReducer,
    customer: customerReducer,
    notification: notificationReducer,
    inquiry: inquiryReducer,
    style: persistedStyleReducer, // ⭐ Gunakan persisted reducer
    paymentLinking: paymentLinkingReducer, // ⭐ Payment Linking reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // ⭐ Ignore redux-persist actions
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

// ⭐ Create persistor
export const persistor = persistStore(store);
export default store;